import { useState } from 'react';

import { Divider } from '@mui/material';
import {
  Bar,
  BarChart as Chart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { useGetWalletDownloadsQuery } from 'src/features/analytics/api/analyticsApi';
import { GetAnalyticsResponse } from 'src/features/analytics/models';
import { useCheckError } from 'src/features/hooks';

import ChartFilterButtons, {
  BUTTONS_TYPE,
} from '../ChartFilterButtons/ChartFilterButtons';

import './DownloadsChart.scss';

enum TABS {
  TODAY = 'Today',
  WEEK = 'Week',
  MONTH = 'Month',
}

const DownloadsChart = () => {
  const [selectedTab, setSelectedTab] = useState<TABS>(TABS.TODAY);

  const { data: walletDownloads, isError } = useGetWalletDownloadsQuery();
  useCheckError(isError, 'Error loading downloads');

  const FILTERS = [
    {
      name: TABS.TODAY,
      onClick: () => setSelectedTab(TABS.TODAY),
      selected: selectedTab === TABS.TODAY,
    },
    {
      name: TABS.WEEK,
      onClick: () => setSelectedTab(TABS.WEEK),
      selected: selectedTab === TABS.WEEK,
    },
    {
      name: TABS.MONTH,
      onClick: () => setSelectedTab(TABS.MONTH),
      selected: selectedTab === TABS.MONTH,
    },
  ];

  const data = {
    [TABS.TODAY]: walletDownloads?.data.day.slice(0).reverse() ?? [],
    [TABS.WEEK]: walletDownloads?.data.week.slice(0).reverse() ?? [],
    [TABS.MONTH]: walletDownloads?.data.month.slice(0).reverse() ?? [],
  };

  const count = {
    [TABS.TODAY]: (
      walletDownloads as unknown as GetAnalyticsResponse
    )?.data.day?.reduce(
      (accumulator, currentValue) => accumulator + Number(currentValue.value),
      0
    ),
    [TABS.WEEK]: (
      walletDownloads as unknown as GetAnalyticsResponse
    )?.data.week?.reduce(
      (accumulator, currentValue) => accumulator + Number(currentValue.value),
      0
    ),
    [TABS.MONTH]: (
      walletDownloads as unknown as GetAnalyticsResponse
    )?.data.month?.reduce(
      (accumulator, currentValue) => accumulator + Number(currentValue.value),
      0
    ),
  };

  return (
    <div className="chart wallet-downloads-chart">
      <div className="count-box">
        <div className="count-box__number">{count[selectedTab] ?? 0}</div>
        <div className="count-box__label">Downloads</div>
      </div>
      <div className="chart__body">
        <ChartFilterButtons filters={FILTERS} type={BUTTONS_TYPE.TEXT} />
        <Divider />
        <ResponsiveContainer width="100%" height="90%">
          <Chart
            data={data[selectedTab]}
            margin={{
              top: 20,
              right: 50,
              left: 0,
              bottom: 5,
            }}
          >
            <XAxis dataKey="name" style={{ fontSize: '14px' }} />
            <YAxis allowDecimals={false} style={{ fontSize: '14px' }} />
            <Tooltip />
            <Bar
              dataKey="value"
              stackId="a"
              fill="var(--ncap-600)"
              radius={[4, 4, 0, 0]}
            />
          </Chart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DownloadsChart;
